import React from 'react';
import styles from './TextEffectsBauhaus.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';
import cx from 'clsx';
import { usePatterns, Patterns } from '../../TextEffectsShared/viewer/patterns';

export type TextEffectsBauhausProps = TextEffectsSharedProps;

const TextEffectsBauhaus: React.FC<TextEffectsSharedProps> = props => {
  const { content, arePatternsDisabled } = usePatterns(props);

  return (
    <TextEffectsShared
      {...props}
      arePatternsDisabled={arePatternsDisabled}
      tagProps={{
        'data-testid': TestIds.viewer.container,
      }}
    >
      <Patterns
        content={content}
        arePatternsDisabled={arePatternsDisabled}
        patternScope={props.patternScope}
        unitProps={data => ({
          className: styles.container,
          'data-text': data,
          disabledPattern: arePatternsDisabled,
        })}
        unitPredicate={data => (
          <span
            className={cx(styles.text, styles.block)}
            data-testid={TestIds.viewer.text}
          >
            {data}
          </span>
        )}
      />
    </TextEffectsShared>
  );
};

export default TextEffectsBauhaus;
